import { NavLink, Outlet } from 'react-router-dom';
import { SystemRole } from '@fleet/shared';
import { useAuth } from '../auth/useAuth';

/**
 * Zweite Navigationsebene für die Verwaltung.
 *
 * Die Stammdatenseiten standen bisher gleichrangig neben Kalender und eigenen
 * Buchungen — obwohl sie eine Handvoll Menschen betreffen und der Rest der
 * Belegschaft sie nie anfasst. Gebündelt unter „Admin" bleibt die Kopfzeile
 * einzeilig, und dass die drei Seiten zusammengehören, ist sichtbar.
 *
 * Die Schranke sitzt weiterhin in `RequireRole` eine Ebene darüber: Diese
 * Komponente stellt nur dar.
 */
export function AdminLayout() {
  const auth = useAuth();

  return (
    <div className="space-y-6">
      <nav className="flex gap-6 border-b border-slate-200">
        <SubTab to="/admin/vehicles">Fahrzeuge</SubTab>
        {/*
          Der Berechtigungs-Editor liegt unter dieser Adresse — ohne `end`
          bleibt der Reiter dort markiert, statt die Auswahl leer wirken zu
          lassen.
        */}
        <SubTab to="/admin/vehicle-groups">Fahrzeuggruppen</SubTab>
        <SubTab to="/admin/bookings">Alle Buchungen</SubTab>
        {/*
          Geräte sind Stammdaten und stehen deshalb auch der Fuhrparkleitung
          offen — dort steht nur, welcher Logger in welchem Fahrzeug sitzt.
        */}
        <SubTab to="/admin/devices">Geräte</SubTab>
        {/*
          Nur für die Administration — der Endpunkt dahinter ist es auch. Ein
          Reiter, der zuverlässig 403 liefert, ist schlechter als keiner.
        */}
        {/* Nutzer und Rohdaten sind der Administration vorbehalten: Der eine
            Reiter setzt Slack-Verknüpfungen und entscheidet damit mit, wer
            freigeben darf, der andere zeigt unredigierte Positionen. */}
        {auth.hasRole(SystemRole.ADMIN) && <SubTab to="/admin/users">Nutzer</SubTab>}
        {/* Zustellwege prüfen: Hier stehen Angaben aus der Konfiguration, und
            ein Knopf schickt Nachrichten an frei gewählte Empfänger. */}
        {auth.hasRole(SystemRole.ADMIN) && (
          <SubTab to="/admin/integrations">Integrationen</SubTab>
        )}
        {auth.hasRole(SystemRole.ADMIN) && <SubTab to="/admin/telemetry">Rohdaten</SubTab>}
      </nav>

      <Outlet />
    </div>
  );
}

function SubTab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        [
          '-mb-px border-b-2 px-1 pb-3 text-sm transition-colors',
          isActive
            ? 'border-slate-900 font-medium text-slate-900'
            : 'border-transparent text-slate-500 hover:text-slate-900',
        ].join(' ')
      }
    >
      {children}
    </NavLink>
  );
}
